export default __webpack_public_path__ + "static/media/shark.857cc562.jpg";